<template>
  <div class="plat-order-query">
    <div class="page-inner">
      <div class="card search-card">
        <div class="card-title">订单查询</div>
        <div class="field-block">
          <label class="field-label" for="ecommerceOrderNo">电商订单号</label>
          <input
            id="ecommerceOrderNo"
            v-model.trim="orderNo"
            class="field-input"
            type="text"
            placeholder="请输入电商订单号"
            @keyup.enter="handleSearch"
          />
        </div>
        <van-button
          class="search-btn"
          type="info"
          block
          round
          :loading="loading"
          loading-text="查询中..."
          @click="handleSearch"
        >
          查询
        </van-button>
      </div>

      <div v-if="searched && !loading" class="card result-card">
        <div class="card-title">查询结果</div>
        <div class="result-row">
          <span class="result-label">订单是否存在</span>
          <span class="result-value" :class="result.exist ? 'is-yes' : 'is-no'">
            {{ result.exist ? '是' : '否' }}
          </span>
        </div>
        <div class="result-row">
          <span class="result-label">订单状态</span>
          <span class="result-value">{{ orderStatusText }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryByOrderNo } from '@/api/platOrderEcs'

const ORDER_STATUS_MAP = {
  0: '待发货',
  1: '已发货',
  2: '发货失败'
}

export default {
  name: 'PlatOrderEcsOrderQuery',
  data() {
    return {
      orderNo: '',
      loading: false,
      searched: false,
      result: {
        exist: false,
        orderStatus: null
      }
    }
  },
  computed: {
    orderStatusText() {
      if (!this.result.exist) return '—'
      const status = this.result.orderStatus
      if (status === null || status === undefined || status === '') return '—'
      return ORDER_STATUS_MAP[status] ?? '—'
    }
  },
  methods: {
    resetResult() {
      this.result = {
        exist: false,
        orderStatus: null
      }
    },
    async handleSearch() {
      if (!this.orderNo) {
        this.$toast.fail('请输入电商订单号')
        return
      }
      this.loading = true
      this.searched = false
      this.resetResult()
      try {
        const { code, data } = await queryByOrderNo(this.orderNo)
        if (code === 0 && data) {
          this.result = {
            exist: !!data.exist,
            orderStatus: data.orderStatus
          }
        }
      } catch (error) {
        console.error('订单查询失败', error)
      } finally {
        this.loading = false
        this.searched = true
      }
    }
  }
}
</script>

<style lang="less" scoped>
.plat-order-query {
  min-height: 100vh;
  padding: 16px;
  background: linear-gradient(180deg, #f0f5ff 0%, #f7f8fa 120px, #f7f8fa 100%);
  box-sizing: border-box;

  .page-inner {
    width: 100%;
    max-width: 480px;
    margin: 0 auto;
  }

  .card {
    background: #fff;
    border-radius: 12px;
    padding: 20px 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  }

  .search-card {
    .card-title {
      margin-bottom: 16px;
      font-size: 17px;
      font-weight: 600;
      color: #323233;
      line-height: 24px;
    }

    .field-block {
      margin-bottom: 16px;
    }

    .field-label {
      display: block;
      margin-bottom: 8px;
      font-size: 14px;
      color: #646566;
      line-height: 20px;
    }

    .field-input {
      width: 100%;
      height: 44px;
      padding: 0 12px;
      border: 1px solid #dcdee0;
      border-radius: 8px;
      font-size: 15px;
      color: #323233;
      background: #fafafa;
      box-sizing: border-box;
      transition: border-color 0.2s, background-color 0.2s;

      &::placeholder {
        color: #c8c9cc;
      }

      &:focus {
        border-color: #1989fa;
        background: #fff;
        outline: none;
      }
    }

    .search-btn {
      margin-top: 4px;
    }
  }

  .result-card {
    margin-top: 16px;

    .card-title {
      margin-bottom: 4px;
      padding-bottom: 12px;
      font-size: 16px;
      font-weight: 600;
      color: #323233;
      border-bottom: 1px solid #ebedf0;
    }

    .result-row {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 12px;
      padding: 14px 0;
      font-size: 14px;
      line-height: 22px;

      & + .result-row {
        border-top: 1px solid #f5f6f7;
      }
    }

    .result-label {
      flex-shrink: 0;
      color: #969799;
    }

    .result-value {
      flex: 1;
      text-align: right;
      word-break: break-all;
      color: #323233;
      font-weight: 500;

      &.is-yes {
        color: #07c160;
      }

      &.is-no {
        color: #ee0a24;
      }
    }
  }
}

@media screen and (min-width: 768px) {
  .plat-order-query {
    padding: 40px 24px;

    .page-inner {
      max-width: 420px;
    }

    .card {
      padding: 24px 20px;
    }
  }
}
</style>
